import React, { useState } from "react";
import "./OnionPage.css"; // Include styling here or in a separate file
import { EnquiryForm } from "./EnquiryForm"; // Ensure EnquiryForm is defined elsewhere
import productimg1 from "../../assets/img/Picture1.jpg"
import productimg2 from "../../assets/img/Picture2.jpg"
import productimg3 from "../../assets/img/Picture3.jpg"
import productimg4 from "../../assets/img/Picture4.jpg"
import productimg5 from "../../assets/img/Picture5.jpg"

const productData = [
    {
        id: 1,
        serviceimage: productimg1,
        cardtitle: "Bold Peanuts",
        title: "Bold Peanuts",
        description: "Premium quality Bold Peanuts for various uses.",
        specifications: {
            Type: "Bold Peanuts",

            Count: "38/42 , 40/50 , 50/60 & 60/70",
            Cleaning: "Sortex Cleaned",
            Moisture: "8% max",
            Admixture: "1% max",
            Foreignmaterial: "0.5%max",
            Brokenandsplits: "1%max",
            Oilcontent: "48-52%",
            Packing: "25/50kg Jute bag , pp bag , vacuum bag",
            Origin: "India",

        },
        image: productimg1,
        servicelink: "/peanuts"
    },
    {
        id: 2,
        serviceimage: productimg2,
        cardtitle: "Java Peanut",
        title: "Java Peanut",
        description: "Premium quality Java Peanut for various uses.",
        specifications: {
            Type: "Java Peanut",



            Count: "40/50, 50/60, 60/70, 70/80, 80/90",
            Cleaning: "Sortex Cleaned",
            Moisture: "8% max",
            Admixture: "1% max",
            Foreignmaterial: "0.5%max",
            Packing: "25/50 kg in jute bag , pp bag or vacuum bag",

            Origin: "India",


        },
        image: productimg2,
        servicelink: "/peanuts"
    },
    {
        id: 3,
        serviceimage: productimg3,
        cardtitle: "TJ Peanut",
        title: "TJ Peanut",
        description: "Premium quality TJ Peanut for various uses.",
        specifications: {
            Type: "TJ Peanut",
            Count: "50/60 & 80/90",
            Cleaning: "Sortex Cleaned",
            Moisture: "8% max",
            Admixture: "1% max",
            Foreignmaterial: "0.5%max",
            Packing: "25/50 kg in jute bag , pp bag or vacuum bag",

            Origin: "India",

        },
        image: productimg3,
        servicelink: "/peanuts"
    },
    {
        id: 4,
        serviceimage: productimg4,
        cardtitle: "Blanched Peanuts / Roasted Blanched Peanuts / Salted Blanched Peanuts",
        title: "Blanched Peanuts / Roasted Blanched Peanuts / Salted Blanched Peanuts",
        description: "Premium quality Blanched Peanuts / Roasted Blanched Peanuts / Salted Blanched Peanuts for various uses.",
        specifications: {
            Type: "Blanched Peanuts / Roasted Blanched Peanuts / Salted Blanched Peanuts",
            Count: "38/42 , 40/50 , 50/60",
            Cleaning: "Sortex Cleaned",
            Color: "Creaming White / Brown",

            Moisture: "4% max",
            Splits: "1% max",
            Admixture: "1% max",
            Packing: "vacuum or pp bag",

            Origin: "India",

        },
        image: productimg4,
        servicelink: "/peanuts"
    },
    {
        id: 5,
        serviceimage: productimg5,
        cardtitle: "Peanut split (Raw/Blanched)",
        title: "Peanut split (Raw/Blanched)",
        description: "Premium quality Peanut split (Raw/Blanched) for various uses.",
        specifications: {
            Type: "Peanut split (Raw/Blanched)",
            Size: "40/50, 50/60",
            RedSkin: "5 % Max",
            Packing: "25/50kg pp bag or vacuum bag",
            Origin: "India",

        },
        image: productimg5,
        servicelink: "/peanuts"
    },

];

export const Peanuts = () => {

    const handleShareClick = () => {
        const textToShare = encodeURIComponent(
            'Check out this awesome link: https://example.com'
        );
        const whatsappUrl = `whatsapp://send?text=${textToShare}`;
        window.location.href = whatsappUrl;
    };
    const phoneNumber = '9926122299'; // Replace with the desired phone number
    const message = 'Hello, I would like to Enquire about your services.'; // Optional: Pre-filled message

    // WhatsApp API URL
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    const [isFormOpen, setIsFormOpen] = useState(false);

    const openForm = () => {
        setIsFormOpen(true);
    };

    const closeForm = () => {
        setIsFormOpen(false);
    };

    return (
        <section className="product-page-section">
            <div className="product-page-container">
                {productData.map((product) => (
                    <div key={product.id} className="singleproduct-card">
                        {/* Product Image */}
                        <div className="singleproduct-image">
                            <img src={product.image} alt={product.title} />
                        </div>

                        {/* Product Content */}
                        <div className="singleproduct-content">
                            <h1>{product.title}</h1>
                            <p>{product.description}</p>

                            {/* Product Specifications */}
                            <table className="singleproduct-specs-table">
                                <thead>
                                    <tr>
                                        <th>Specification</th>
                                        <th>Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(product.specifications).map(
                                        ([key, value], index) => (
                                            <tr key={index}>
                                                <td>{key}</td>
                                                <td>{value}</td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>

                            {/* Action Buttons */}
                            <div className="product-action-buttons">
                                <button className="request-a-call">
                                    <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" >
                                        <i className="fas fa-phone"></i> Send whatsapp
                                    </a>
                                </button>
                                <button className="send-enquiry" onClick={openForm}>
                                    <i className="fa fa-envelope"></i> Send Enquiry
                                </button>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Enquiry Form */}
                {isFormOpen && <EnquiryForm onClose={closeForm} />}
            </div>
        </section>
    );
};
